import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../../tailwind.config';
const { theme } = resolveConfig(tailwindConfig);
const fontSizeClasses = Object.keys(theme.fontSize).map((size) => `text-${size}`);
/**
 * This object should only be used within the customTV !
 *
 * @see customTV
 */
export const fontSizeClassesConfig = {
    'font-size': [...fontSizeClasses, 'text-[0.8125rem]', 'text-[1.0625rem]'],
};
